import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import PATHS from '~/app/utils/paths';
import { ENABLE_FF91_PREORDER, ENABLE_FX_SIMPLE_PREORDER, ENABLE_FF_ROBOT_PREORDER } from '~/app/settings';
import FXPreorderLayout from '~/app/layouts/FXPreorderLayout';
import FFRobotPreorderLayout from '~/app/layouts/FFRobotPreorderLayout';
import loadable from '@loadable/component';

// Use loadable to load the actual components
const FF91PreorderPage = loadable(() => import(/* webpackChunkName: "FF91PreorderPage" */ '~/app/pages/FF91PreorderPage'));
// const FXSimplePreorderPage = loadable(() => import(/* webpackChunkName: "FXSimplePreorderPage" */ '~/app/pages/FXSimplePreorderPage'));
const FXSimplePreorderPage717 = loadable(() => import(/* webpackChunkName: "FXSimplePreorderPage717" */ '~/app/pages/FXSimplePreorderPage717'));
const FFRobotPreorderPage = loadable(() => import(/* webpackChunkName: "FFRobotPreorderPage" */ '~/app/pages/FFRobotPreorderPage'));
// const FXEarlyAccessPreorderPage = loadable(() => import(/* webpackChunkName: "FXEarlyAccessPreorderPage" */ '~/app/pages/FXEarlyAccessPreorderPage'));

// Simple redirect component
const FXEarlyAccessRedirect = () => {
  const location = useLocation();
  return <Redirect to={`/us${PATHS.RESERVE}${PATHS.FX_SIMPLE_PREORDER}${location.search}`} />;
};

const ReserveRouter = () => (
  <Switch>
    {/* FX routes need to be first to ensure they take precedence */}
    <Route exact path={`/:locale(us)${PATHS.RESERVE}${PATHS.FX_EARLY_ACCESS_PREORDER}`} >
      <FXEarlyAccessRedirect />
    </Route>
    
    {/* FX Simple Preorder Reserve route - use custom layout */}
    {ENABLE_FX_SIMPLE_PREORDER && (
      <Route exact path={`/:locale(us)${PATHS.RESERVE}${PATHS.FX_SIMPLE_PREORDER}`} >
        <FXPreorderLayout>
          <FXSimplePreorderPage717 modelCode='FX Super One' />
        </FXPreorderLayout>
      </Route>
    )}

    {/* FF Robot Preorder Reserve route */}
    {ENABLE_FF_ROBOT_PREORDER && (
      <Route exact path={`/:locale(us)${PATHS.RESERVE}${PATHS.FF_ROBOT_PREORDER}`} >
        <FFRobotPreorderLayout>
          <FFRobotPreorderPage />
        </FFRobotPreorderLayout>
      </Route>
    )}

    {ENABLE_FF91_PREORDER && (
      <>
        <Route exact path={`/:locale(us)${PATHS.RESERVE}${PATHS.FF91_PREORDER}`} component={FF91PreorderPage} />
        <Route exact path={`/:locale(us)${PATHS.RESERVE}${PATHS.FF91_FUTURIST_PREORDER}`} >
          <FF91PreorderPage modelCode='FF91FNA' />
        </Route>
      </>
    )}
    <Redirect to="/:locale(us|cn)/404" />
  </Switch>
);

export default ReserveRouter;